import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Data } from "@angular/router";

@Injectable()
export class DataIntegrityService {
  constructor(private dataService: DataService) {
  }
  url = environment.api_base_url;

  getDataIntegrityList(date: Date, status: string): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url + "dataentry/view-integrity?date=" + date + "&status=" + status).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  getDownloadURL(date: Date, status: string): any {
    const authToken = sessionStorage.getItem("authToken");
    return this.url + "dataentry/view-integrity/download?date=" + date + "&status=" + status + "&token=" + authToken;
  }

  downloadIntegrity(date: Date, status: string): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.download(this.url + "dataentry/view-integrity/download?date=" + date + "&status=" + status).subscribe((result: any) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }
}